import { ReactNode } from 'react'
import { Popover, Tag } from 'antd'
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import { SkillDetail } from './AllocationTable'

type MatchSkillsPopoverProps = {
  children: ReactNode
  skills?: SkillDetail[]
}

const MatchSkillsPopover = ({ children, skills }: MatchSkillsPopoverProps) => {
  const { t } = useTranslation()

  if (!skills) return null

  return (
    <Popover
      placement="bottomRight"
      showArrow
      trigger="hover"
      arrow={{ pointAtCenter: true }}
      content={
        <SkillsPopover>
          <Text weight="medium" level={2}>
            {t('SKILLS')}
          </Text>
          {skills.map((skill: SkillDetail) => (
            <StyledTag
              key={skill.name}
              color={skill.selected ? 'green' : 'red'}
            >
              <Text weight="medium" level={2}>
                {skill.name}
              </Text>
            </StyledTag>
          ))}
        </SkillsPopover>
      }
    >
      {children}
    </Popover>
  )
}

const StyledTag = styled(Tag)`
  padding: 4px 8px;
  margin: 0;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
`

const SkillsPopover = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding: 4px;
`

export default MatchSkillsPopover
